import React from "react";
import { Link } from "react-router-dom";

export const NotFound = () => {
  return (
    <div className="center-content my-4">
      <h1>Oops, that didn't work.</h1>
      <p>
        <span>That page wasn't found.</span>
        <br />
        <Link to="/">Click here to navigate to the main page</Link>
      </p>
    </div>
  );
};
